import Config from "../config.js";
import { createRequestOptions } from "./utils";
import { get } from "lodash";

import { resetAuthTokenFromUserAction } from "../actions/auth";
import store from "../store";

export default () => {
  return Object.freeze({
    userLogin: async (userInfo) => {
      const options = createRequestOptions({ userInfo });
      const result = await fetch(Config.serverUrl + "/UserLogin", options);
      const response = await result.json();

      return get(response, "response");
    },
    passwordReset: async (email, appCode) => {
      const options = createRequestOptions({ email, appCode });
      const result = await fetch(Config.serverUrl + "/PasswordReset", options);
      const response = await result.json();

      return get(response, "response");
    },
    validateToken: async (token) => {
      const options = createRequestOptions({ token });
      const result = await fetch(
        Config.serverUrl + "/ValidatePasswordResetToken",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    setNewUserPassword: async (token, password) => {
      const options = createRequestOptions({ token, password });
      const result = await fetch(
        Config.serverUrl + "/SetNewUserPassword",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    refreshUserAuth: async (refreshToken) => {
      const options = createRequestOptions({
        refreshToken,
      });
      const result = await fetch(
        Config.serverUrl + "/RefreshUserAuth",
        options
      );
      const response = await result.json();

      const action = resetAuthTokenFromUserAction(response);
      store.dispatch(action);

      return get(response, "response");
    },
    getUserInfo: async (userId) => {
      const options = createRequestOptions({ userId });

      const result = await fetch(Config.serverUrl + "/GetUserInfo", options);
      const response = await result.json();

      return get(response, "response");
    },
    updateUserPassword: async (userAuth0Id, password) => {
      const options = createRequestOptions({ userAuth0Id, password });
      const result = await fetch(
        Config.serverUrl + "/UpdateUserPassword",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    updateUserInfo: async (userId, userAuth0Id, userInfo) => {
      const options = createRequestOptions({ userId, userAuth0Id, userInfo });
      const result = await fetch(Config.serverUrl + "/UpdateUserInfo", options);
      const response = await result.json();

      return get(response, "response");
    },
  });
};



// WEBPACK FOOTER //
// ./src/services/user.js